import { render, staticRenderFns } from "./ReleaseShortcutNav.vue?vue&type=template&id=fcf887f4&"
import script from "./ReleaseShortcutNav.vue?vue&type=script&lang=js&"
export * from "./ReleaseShortcutNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports